<script setup lang="ts">
/**
 * GlobalOverlay · 全屏覆盖层
 * ------------------------------------------------------------
 * 原型对应：.overlay + openOverlay/closeOverlay
 * 架构浏览器 / 全量表 / 详情弹层的宿主。
 * M0 只提供空壳，等 M1 架构浏览器落地后用 Teleport 填充。
 */
</script>

<template>
  <div class="global-overlay" id="__globalOverlay" style="display:none">
    <!-- 各业务模块通过 Teleport 把内容放进来 -->
    <slot />
  </div>
</template>

<style scoped>
.global-overlay {
  position: fixed; inset: 0;
  z-index: 300;
  background: var(--bg);
  padding-top: 56px; /* header 高度 */
}
</style>
